/* eslint-disable max-len */

import { LandingNames } from 'Pages/landings/common/constants/LandingNames'

export const AdriverSrc = {
	[LandingNames.CREDITS]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4388157&bid=12390298&bn=12390298&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
}
